export type AppConfig = {
  alertActive: string
  alertHref: string
  alertText: string
  apiToken: string
  apiUrl: string
  googleGeoApiKey: string
  googleRecaptchaSiteKey: string
  notification: string
  region: string
  trailFinderSponsorHref: string
  trailFinderSponsorImageUrl: string
}

const DEFAULT_CONFIG: AppConfig = {
  alertActive: 'false',
  alertHref: '/',
  alertText: '',
  apiToken: 'iQyYMVPhri6WiZlEU40078SpLLtAB0cDavuMud0V',
  apiUrl: 'https://blnpsrxfd9.execute-api.us-east-1.amazonaws.com/prod/',
  googleGeoApiKey: 'AIzaSyCX7h5XLr6ZB76B6lZR_-8ByckJpedCoBg',
  googleRecaptchaSiteKey: '6LdJ8XAcAAAAAMAcnLY5DMH4JEu2rgsUNnrJ7WrV',
  notification:
    "<a style='display: block; padding-top: 8px; padding-bottom: 8px;' href='https://www.flowfeed.app/' target='_blank' rel='noreferrer'><svg class='MuiSvgIcon-root MuiSvgIcon-fontSizeInherit css-1xs46ct' focusable='false' aria-hidden='true' viewBox='0 0 325 167.1' data-testid='FlowfeedLogoIconIcon' style='font-size: 70px;'><g><path fill='#FFFFFF' stroke='#FFFFFF' stroke-width='4' stroke-miterlimit='10' d='M129.1,20.1L129.1,20.1l-4.6-3.9l-3.6,4.2l-0.3,0.4L17.5,142.6L77.8,118l42.7,34.2l75.7-89.9l26.4,22.4h9.3l-31.9-27l27.8-33l70.5,59.5h9.3l-80.5-68l-32.9,39l-2.7,3.2l0,0l-7.3,8.6l-3.9,4.6l-60.8,72.2l-40.9-32.7l-41,16.7l55.5-65.6L120,84.7h9.3L97.3,57.7l27.6-32.6l0.3-0.4L129.1,20.1z'></path><linearGradient id='SVGID_1_' gradientUnits='userSpaceOnUse' x1='191.9943' y1='47.6311' x2='130.9809' y2='41.0455'><stop offset='0.08833618' stop-color='#FFFFFF' stop-opacity='0'></stop><stop offset='0.325' stop-color='#FFFFFF' stop-opacity='0.502'></stop><stop offset='0.8895' stop-color='#FFFFFF'></stop></linearGradient><path fill='url(#SVGID_1_)' d='M179.2,73.1l-55.4-47l-5.6-5.5l6.1-7.2L132,20l0,0l53.6,45.5L179.2,73.1z'></path></g></svg></a>",
  region: 'NWA',
  trailFinderSponsorHref: '',
  trailFinderSponsorImageUrl: '',
}

const REGION_CONFIG_OVERRIDES: Record<string, Partial<AppConfig>> = {
  NWA: {
    alertActive: 'true',
    alertHref: '/trail-finder',
    alertText:
      "<div style='width: 100%; display: flex; justify-content: center; align-items: center; background: #d4d4d4; border-radius: 12px; padding: 8px;'><div style='font-size: 1.5em; color: #000; font-weight: 700; padding-right: 0.3em; padding-bottom: 0.2em;'>Trail Finder</div><div style='font-size: 1em; color: #000;'>by</div><img src='https://wp-flowfeed.s3.us-east-2.amazonaws.com/wp-content/uploads/2023/02/26215533/VB-Black-1.png' alt='Visit Bentonville' style='max-height: 3em;'></div>",
    trailFinderSponsorHref: 'https://www.visitbentonville.com',
    trailFinderSponsorImageUrl:
      'https://wp-flowfeed.s3.us-east-2.amazonaws.com/wp-content/uploads/2023/02/26215533/VB-White-1.png',
  },
}

const readEnvOverride = (value: string | undefined): string | undefined => {
  if (typeof value !== 'string') {
    return undefined
  }

  const trimmed = value.trim()
  return trimmed.length ? trimmed : undefined
}

const resolvedRegion = readEnvOverride(process.env.REACT_APP_REGION) ?? DEFAULT_CONFIG.region
const regionConfig = REGION_CONFIG_OVERRIDES[resolvedRegion] ?? {}
const configWithRegionDefaults: AppConfig = {
  ...DEFAULT_CONFIG,
  ...regionConfig,
  region: resolvedRegion,
}

export const AppConfigProvider: AppConfig = {
  alertActive: readEnvOverride(process.env.REACT_APP_ALERT_ACTIVE) ?? configWithRegionDefaults.alertActive,
  alertHref: readEnvOverride(process.env.REACT_APP_ALERT_HREF) ?? configWithRegionDefaults.alertHref,
  alertText: readEnvOverride(process.env.REACT_APP_ALERT_TEXT) ?? configWithRegionDefaults.alertText,
  apiToken: readEnvOverride(process.env.REACT_APP_API_TOKEN) ?? configWithRegionDefaults.apiToken,
  apiUrl: readEnvOverride(process.env.REACT_APP_API_URL) ?? configWithRegionDefaults.apiUrl,
  googleGeoApiKey:
    readEnvOverride(process.env.REACT_APP_GOOGLE_GEO_API_KEY) ?? configWithRegionDefaults.googleGeoApiKey,
  googleRecaptchaSiteKey:
    readEnvOverride(process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY) ?? configWithRegionDefaults.googleRecaptchaSiteKey,
  notification: readEnvOverride(process.env.REACT_APP_NOTIFICATION) ?? configWithRegionDefaults.notification,
  region: readEnvOverride(process.env.REACT_APP_REGION) ?? configWithRegionDefaults.region,
  trailFinderSponsorHref:
    readEnvOverride(process.env.REACT_APP_TRAIL_FINDER_SPONSOR_HREF) ?? configWithRegionDefaults.trailFinderSponsorHref,
  trailFinderSponsorImageUrl:
    readEnvOverride(process.env.REACT_APP_TRAIL_FINDER_SPONSOR_IMAGE_URL) ??
    configWithRegionDefaults.trailFinderSponsorImageUrl,
}
